module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#gears",
      toString: function () {
        return this.url;
      }
    }